import {Spacer, Typography} from 'nf-ui'
import React from 'react'
import {MeetingsThisWeek_meetingsThisWeek} from '../Meetings/__types__/MeetingsThisWeek'
import {Meeting} from './Meeting'
import {useOrganisationIdStr} from '~/components/useOrganisationIdStr'
import {useQueryDataEditGetFields} from '~/apollo/queries/DataEditField'
import {useQueryDataEditGetValues} from '~/apollo/queries/DataEditValue'
import {useQueryProfileLines} from '~/apollo/queries/ProfileLine'
import {getGraphQLErrorMessage} from '~/util'
import {PageLoading} from '~/components/PageLoading'
import {UserlandActionBar} from '../ActionBar'

export const MeetingsList = ({meetings}: {meetings: MeetingsThisWeek_meetingsThisWeek[]}) => {
    const orgIdStr = useOrganisationIdStr()
    const [fieldsData, dataEditFields] = useQueryDataEditGetFields(orgIdStr)
    const [valuesData, dataEditValues] = useQueryDataEditGetValues(orgIdStr)
    const [linesData, profileLines] = useQueryProfileLines(orgIdStr)

    if (fieldsData.error) return <Typography.Heading>{getGraphQLErrorMessage(fieldsData.error)}</Typography.Heading>
    if (valuesData.error) return <Typography.Heading>{getGraphQLErrorMessage(valuesData.error)}</Typography.Heading>
    if (linesData.error) return <Typography.Heading>{getGraphQLErrorMessage(linesData.error)}</Typography.Heading>

    if (fieldsData.loading || valuesData.loading || linesData.loading)
        return (
            <>
                <PageLoading />
                <UserlandActionBar loading />
            </>
        )

    return (
        <>
            {meetings.map((meeting, index) => {
                return (
                    <React.Fragment key={index}>
                        <Meeting
                            meeting={meeting}
                            firstMeeting={index === 0}
                            data={{profileLines, dataEditFields, dataEditValues}}
                        />
                        <Spacer height={8} />
                    </React.Fragment>
                )
            })}
        </>
    )
}
